<section>
  <div class="header">
    <h1>{{ 'PROFILE_SETTINGS_FORM.HEADER' | translate }}</h1>
    <astral-button class="btn-list-header" variant="primary" type="button" labelKey="SAVE_BTN" [disabled]="!form" (click)="onSubmit()"></astral-button>
  </div>

  @if (form) {
    <form class="astral-content-width astral-accordion-stack" [formGroup]="form" (ngSubmit)="onSubmit()">
      <astral-accordion [header]="'PROFILE_SETTINGS_FORM.INVOICING'">
        <div class="astral-stack-l">
          <div class="astral-form-stack">
            <astral-toggle [control]="form.controls['enableInvoicing']"></astral-toggle>

            @if (form.controls['enableInvoicing'].value) {
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
              <astral-checkbox [control]="form.controls['autoAttest']" [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.AUTOATTEST'"></astral-checkbox>
              <astral-select
                [control]="form.controls['invoiceDeliveryMethod']"
                [itemsSource]="invoiceDeliveryMethods"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.INVOICE_DELIVERY_METHOD'"
              ></astral-select>
              @if (hasEInvoiceB2CEnabled) {
                <astral-toggle [control]="form.controls['enableEInvoiceB2C']"></astral-toggle>
              }
              <astral-checkbox
                [control]="form.controls['displayOrganizationNo']"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.DISPLAY_ORGANIZATION_NO'"
              ></astral-checkbox>
              <astral-checkbox
                [control]="form.controls['includeQRCodeInEmailBody']"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.INCLUDE_QRCODE_IN_EMAIL_BODY'"
              ></astral-checkbox>
              </astral-layout-group>

              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
              <astral-input
                [control]="form.controls['rentInvoiceCaption']"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.INVOICE_LAYOUT_CAPTION'"
              ></astral-input>
              <astral-select
                [control]="form.controls['leaseAgreementInformationRowContent']"
                [itemsSource]="leaseAgreementInformationRowContentKinds"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.LEASE_AGREEMENT_INFORMATION_ROW_CONTENT'"
              ></astral-select>
              <astral-checkbox
                [control]="form.controls['sendZeroInvoice']"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.SEND_ZERO_INVOICE'"
              ></astral-checkbox>
              <astral-checkbox
                [control]="form.controls['useInvoiceRowGroup']"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.USE_INVOICE_ROW_GROUP'"
              ></astral-checkbox>
              </astral-layout-group>
            }
          </div>

          @if (form.controls['enableInvoicing'].value) {
            <section class="astral-accordion-section">
              <h3 class="astral-section-heading astral-accordion-section__heading">{{ 'INVOICE.PAYMENTS' | translate }}</h3>
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
                <astral-checkbox
                  [control]="form.controls['moveMissingAndAdditionalPaymentDecimalsToRounding']"
                  [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.TREAT_SMALL_INCORRECT_PAYMENTS_AS_ROUNDING'"
                ></astral-checkbox>
                <astral-input
                  type="number"
                  [control]="form.controls['automaticDefermentUpToAmount']"
                  [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.AUTO_DEFERMENT_MAX_AMOUNT'"
                ></astral-input>
              </astral-layout-group>
            </section>
          }
        </div>
      </astral-accordion>

      <astral-accordion [header]="'CLEANUP_SETTINGS_FORM.HEADER'">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['removeTenants']" [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.GDPR_UNIT'"></astral-input>
          <astral-input [control]="form.controls['removeMails']" [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.GDPR_UNIT'"></astral-input>
        </astral-layout-group>
      </astral-accordion>

      <astral-accordion [header]="'PROFILE_SETTINGS_FORM.INTEGRATIONS'">
        <div class="astral-stack-l">
          <div class="astral-form-stack">
            <astral-toggle [control]="form.controls['useFastighetsagarnaDokument']"></astral-toggle>
            @if (form.controls['useFastighetsagarnaDokument'].value) {
              <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input
                  type="password"
                  [control]="form.controls['fastighetsagarnaApiKey']"
                  [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.FASTIGHETSAGARNA_DOKUMENT_API_KEY'"
                ></astral-input>
                <div class="astral-form-adjacent-action">
                  <astral-button
                    variant="secondary"
                    type="button"
                    labelKey="PROFILE_SETTINGS_FORM.FASTIGHETSAGARNA_DOKUMENT_API_KEY_BUTTON"
                    [title]="'PROFILE_SETTINGS_FORM.HELP_TEXT.FASTIGHETSAGARNA_DOKUMENT_API_KEY_BUTTON' | translate"
                    [disabled]="isFDApiKeyButtonDisabled"
                    (click)="sendToFastighetsagarnaApiKey()"
                  ></astral-button>
                </div>
              </astral-layout-group>
            }
          </div>

          <div class="astral-form-stack">
            <astral-toggle [control]="form.controls['useHomeQ']"></astral-toggle>
            @if (form.controls['useHomeQ'].value) {
              <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="form.controls['homeQUsername']"></astral-input>
                <astral-input type="password" [control]="form.controls['homeQPassword']"></astral-input>
              </astral-layout-group>
            }
          </div>

          <div class="astral-form-stack">
            <astral-toggle [control]="form.controls['useAvyApi']"></astral-toggle>
            @if (form.controls['useAvyApi'].value) {
              <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="form.controls['avyApiClientId']" [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.AVY_API_KEY'"></astral-input>
                <astral-input
                  type="password"
                  [control]="form.controls['avyApiClientSecret']"
                  [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.AVY_API_SECRET'"
                ></astral-input>
              </astral-layout-group>
            }
          </div>

          <div class="astral-form-stack">
            <astral-toggle [control]="form.controls['useDhMarket']"></astral-toggle>
            @if (form.controls['useDhMarket'].value) {
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="form.controls['dhMarketBackOfficeDomain']"></astral-input>
                <astral-input [control]="form.controls['dhMarketUserName']"></astral-input>
                <astral-input type="password" [control]="form.controls['dhMarketPassword']"></astral-input>
              </astral-layout-group>
            }
          </div>

          <div class="astral-form-stack">
            <astral-toggle [control]="form.controls['useRopoOne']"></astral-toggle>
            @if (form.controls['useRopoOne'].value) {
              <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="form.controls['ropoOneCid']"></astral-input>
                <astral-input type="password" [control]="form.controls['ropoOneApiKey']"></astral-input>
              </astral-layout-group>
            }
          </div>

          <div class="astral-form-stack">
            <astral-toggle [control]="form.controls['useWebhook']"></astral-toggle>
            @if (form.controls['useWebhook'].value) {
              <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="form.controls['webhookUrl']" [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.WEBHOOK_URL'"></astral-input>
              </astral-layout-group>
            }
          </div>

          @if (showBoplatsSverigeSettings) {
            <div class="astral-form-stack">
              <astral-toggle [control]="form.controls['useBoplatsSverige']"></astral-toggle>
              @if (form.controls['useBoplatsSverige'].value) {
                <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-input type="password" [control]="form.controls['boplatsSverigeCustomerGuid']"></astral-input>
                  <astral-input [control]="form.controls['boplatsSverigeDescriptionUrlPathTemplate']"></astral-input>
                </astral-layout-group>
              }
            </div>
          }
        </div>
      </astral-accordion>

      <astral-accordion [header]="'PROFILE_SETTINGS_FORM.MESSAGES'">
        <div class="astral-stack-l">
          <div class="astral-stack-m">
            <astral-toggle [control]="form.controls['useOwnSendGrid']"></astral-toggle>
            @if (form.controls['useOwnSendGrid'].value) {
              <div class="astral-section-surface astral-stack-m">
                <div>
                  <p>{{ 'PROFILE_SETTINGS_FORM.SENDGRID_INFO.INTRODUCTION' | translate }}</p>
                  <ol>
                    <li>{{ 'PROFILE_SETTINGS_FORM.SENDGRID_INFO.API_KEY' | translate }}</li>
                    <li>{{ 'PROFILE_SETTINGS_FORM.SENDGRID_INFO.SENDER_AUTHENTICATION' | translate }}</li>
                    <li>{{ 'PROFILE_SETTINGS_FORM.SENDGRID_INFO.EVENT_WEBHOOK' | translate }}</li>
                    <li>{{ 'PROFILE_SETTINGS_FORM.SENDGRID_INFO.EVENTS' | translate }}</li>
                    <li>{{ 'PROFILE_SETTINGS_FORM.SENDGRID_INFO.SECURITY' | translate }}</li>
                  </ol>
                  <p>{{ 'PROFILE_SETTINGS_FORM.SENDGRID_INFO.FROM_OVERRIDE' | translate }}</p>
                </div>

                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-input
                    type="password"
                    [control]="form.controls['sendGridApiKey']"
                    [helpText]="
                      hasSendGridApiKey
                        ? 'PROFILE_SETTINGS_FORM.HELP_TEXT.SENDGRID_API_KEY_CONFIGURED'
                        : 'PROFILE_SETTINGS_FORM.HELP_TEXT.SENDGRID_API_KEY'
                    "
                  ></astral-input>
                  <astral-input
                    type="email"
                    [control]="form.controls['emailProviderSenderAddress']"
                    [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.EMAIL_PROVIDER_SENDER_ADDRESS'"
                  ></astral-input>
                  <astral-input [control]="form.controls['emailProviderSenderName']"></astral-input>
                  <astral-input
                    [control]="form.controls['sendGridEventWebhookUrl']"
                    [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.SENDGRID_EVENT_WEBHOOK_URL'"
                    [span]="'full'"
                  ></astral-input>
                </astral-layout-group>

                <div class="astral-stack-m">
                  <div>
                    <h5>{{ 'PROFILE_SETTINGS_FORM.EMAIL_PROVIDER_TEST_HEADER' | translate }}</h5>
                    <p>{{ 'PROFILE_SETTINGS_FORM.EMAIL_PROVIDER_TEST_INFO' | translate }}</p>
                  </div>
                  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
                    <astral-input
                      type="email"
                      [control]="emailProviderTestRecipient"
                      [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.EMAIL_PROVIDER_TEST_RECIPIENT'"
                    ></astral-input>
                    <div class="astral-form-adjacent-action">
                      <astral-button
                        type="button"
                        variant="primary"
                        [labelKey]="'PROFILE_SETTINGS_FORM.EMAIL_PROVIDER_TEST_BUTTON'"
                        [disabled]="isSendingEmailProviderTest"
                        (click)="testEmailProvider()"
                      ></astral-button>
                    </div>
                  </astral-layout-group>
                </div>
              </div>
            }
          </div>

          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select
              [control]="form.controls['mailDeliverySpeed']"
              [itemsSource]="mailDeliverySpeeds"
              [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.MAIL_DELIVERY_SPEED'"
            ></astral-select>
            <astral-input [control]="form.controls['senderOfMessages']" [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.SENDER_OF_MESSAGES'"></astral-input>
            <astral-toggle [control]="form.controls['enableESignature']"></astral-toggle>
            @if (form.controls['enableESignature'].value) {
              <astral-input
                [control]="form.controls['defaultResponseTimeEsigningCase']"
                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.DEFAULT_RESPONSE_TIME_ESIGN_CASE'"
              ></astral-input>
            }
          </astral-layout-group>
        </div>
      </astral-accordion>

      <astral-accordion [header]="'PROFILE_SETTINGS_FORM.GENERALLY'">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input
            type="number"
            [control]="form.controls['inactivityTimeoutMinutes']"
            [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.INACTIVITY_TIMEOUT'"
          ></astral-input>
          <astral-toggle [control]="form.controls['locationAccessControlActive']"></astral-toggle>
        </astral-layout-group>
      </astral-accordion>

      <astral-accordion [header]="'MODULE.NAMES.COOPERATIVE_HOUSING'">
        <div class="astral-form-stack">
          <astral-toggle [control]="form.controls['useBrf']"></astral-toggle>
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
            <astral-input [control]="form.controls['brfControlDataProviderOrganizationNumber']"></astral-input>
            <astral-input [control]="form.controls['brfControlDataProviderName']"></astral-input>
            <astral-input [control]="form.controls['brfControlDataProviderEmail']"></astral-input>
            <astral-input [control]="form.controls['brfControlDataProviderPhone']"></astral-input>
          </astral-layout-group>
        </div>
      </astral-accordion>

      <astral-accordion [header]="'MODULE.NAMES.MORTGAGE'">
        <astral-toggle [control]="form.controls['useMortgage']"></astral-toggle>
      </astral-accordion>

      <!-- Make this a migration button that shows remaing contacts to solve before enabling
      <astral-accordion [header]="'MODULE.NAMES.USER_FEATURES'">
        <astral-toggle [control]="form.controls['enableUserFeatures']"></astral-toggle>
      </astral-accordion> -->
    </form>
  }
</section>
